/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {hasActionsExecuting} from "@ngxs-labs/actions-executing";
import {Select, Store} from "@ngxs/store";
import {TrecReminder} from "@trec/api/clinical-data";
import {C3SnackbarStatusService} from "@trec/components/snackbar-status";
import {StoreAction} from "@trec/components/store";
import {Observable} from "rxjs";
import {TpBaseActions} from "../../../store/patient-treatment-plan-base.actions";
import {CdItemFormComponent, CdItemFormMode} from "../../forms/cd-item-form-component";

@Component({
  selector: "c3-edit-examination-dialog",
  templateUrl: "./edit-examination-dialog.component.html",
  styleUrls: ["./edit-examination-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EditExaminationDialogComponent {
  editMode = false;

  @Select(
    hasActionsExecuting([
      TpBaseActions.FetchExaminations,
      TpBaseActions.InsertExamination,
      TpBaseActions.EditExamination,
    ])
  )
  loading$: Observable<boolean>;

  get mode(): CdItemFormMode {
    return this.reminderToEdit ? (this.editMode ? "edit" : "view") : "insert";
  }

  constructor(
    private store: Store,
    public dialogRef: MatDialogRef<EditExaminationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public reminderToEdit: TrecReminder,
    private c3SnackbarStatus: C3SnackbarStatusService
  ) {
    if (!this.reminderToEdit) {
      this.editMode = true;
    }
  }

  onSubmit(formComp: CdItemFormComponent<TrecReminder[], any>) {
    // Prepare item to submit
    const examinations = formComp.prepareData();

    if (!examinations) {
      return;
    }

    let action: StoreAction;
    let succMsg: string;

    switch (this.mode) {
      case "insert":
        action = new TpBaseActions.InsertExamination({examinations});
        succMsg = `Esami aggiunti correttamente`;
        break;
      case "edit":
        action = new TpBaseActions.EditExamination({examination: examinations[0]});
        succMsg = `Esame modificato correttamente`;
        break;
      default:
        throw new Error(`Cannot do operation in mode ${this.mode}`);
    }

    // Perform action
    this.store.dispatch(action).subscribe(() => {
      this.c3SnackbarStatus.showSuccess({message: succMsg});
      this.dialogRef.close();
    });
  }
}
